import EnterFreespins from "slotworks/state-machine/standard/states/enter-freespins";
import HarleyComponents from "components/components";
import autoplayModel from "slotworks/model/autoplay-model";
import { StopAutoplayCommand } from "slotworks/commands/autoplay/stop-autoplay";
import HidePromoFSonFreespins from "slotworks/commands/promo-free-spins/hide-pfs-on-freespins";
import smartButton, { SmartButtonFlag } from "slotworks/smart-button/smart-button";
import Components from "slotworks/components/components";
import gameState from "slotworks/model/game-state";
import translations from "slotworks/i18n/translations";
import Layers from "slotworks/graphics/layers/layers";
import FreespinsWheelRecord from "integration/records/freespins-wheel-record";
import { BetBarType } from "slotworks/components/betbar/bet-bar-component";
import FreespinsMediator from "mediators/freespins-mediator";

export default class HarleyEnterFreespins extends EnterFreespins {

    public onEnter() {
        HarleyComponents.bonusBuyButton.hide();        
        
        if (autoplayModel.stopOnFeatureWin) {
            StopAutoplayCommand();
        }

        HidePromoFSonFreespins();

        smartButton.setFlag(SmartButtonFlag.PROMPT, true);
        smartButton.setFlag(SmartButtonFlag.FREE_SPINS, true);
        
        Components.betBar.setType(BetBarType.FREESPINS);
        new FreespinsMediator().start().execute();
        
        Layers.Banners.jumpToScene("freespins");
        Layers.Footer.jumpToScene("freespins");
        
        this.showFreespinsWinPrompt().then(() => {
            Layers.Custom.get("MatrixAnim").show();
            // HarleyComponents.background.start();
            this.complete();
        });
    }

    private showFreespinsWinPrompt() {
        const record = gameState.getCurrentGame().getCurrentRecord() as FreespinsWheelRecord;

        const contents = new Map<string, string>();


        contents.set("winMessage", translations.get("fs.tri", { VALUE: record.spinsWon }));
        contents.set("value", record.spinsWon.toString());

        const boosters = record.giftedAdditional;

        if(boosters == 0) {
            return Components.prompt.show(["freespinswin0boosters"], contents);    
        }

        contents.set("boosters", record.giftedAdditional.toString());
        HarleyComponents.messages.setFreespins(boosters);
        return Components.prompt.show(["freespinswin"], contents)
    }
}
